import { useEffect, useState } from 'react';
import { getConfig } from '~/org/twilio/one-support-center/shared/osc-env';

import { constants, types } from './definitions';
import { SupportApi } from '../../clients';
import logger from '../../../lib/logger';

const { priorityLevelFieldId } = getConfig();

function useGetPriorityLevelFields(): types.UseGetPriorityLevelFieldsReturn {
  const [status, setStatus] = useState<types.UseGetPriorityLevelFieldsReturn>({
    priorityLevels: [],
    loading: true,
  });

  useEffect(() => {
    (async (): Promise<void> => {
      try {
        const {
          data: { custom_field_options: priorityLevels },
        } = await SupportApi.getTicketField(priorityLevelFieldId);

        setStatus({
          loading: false,
          priorityLevels,
        });
      } catch (err) {
        logger.error(`${constants.LOG_PREFIX}::${err}`);

        setStatus({
          priorityLevels: [],
          loading: false,
          error: err as Error,
        });
      }
    })();
  }, []);

  return status;
}

export default useGetPriorityLevelFields;
